// a simple default empty quill document object
export const EMPTY_QUILL_DOCUMENT = { ops: [{ insert: '\n' }] }

export const BROWSER_DATE_FORMAT = 'YYYY-MM-DD'

export const ITEMS_PER_PAGE = 40

export const NOTICE_QUILL_FORMATS = ['header', 'bold', 'italic', 'link', 'underline', 'strike', 'list', 'indent', 'blockquote']
